import React from "react";
import Link from "next/link";
import Image from "next/image";
import { ContactDetails, SocialLinks } from "./footer-components";
import ContactForm from "./ContactForm/index";
import Animate from "@/components/Animate";
const currentYear = new Date().getFullYear();

const Footer = () => {
  return (
    <footer
      id="join-waitlist"
      className="gradient-background pb-6 pt-8 sm:pb-10 sm:pt-12 lg:px-8 [@media(min-width:800px)]:px-4 [@media(min-width:800px)]:pb-8 [@media(min-width:800px)]:pt-16"
    >
      <div className="landing-container">
        <div className="flex w-full flex-col justify-between gap-10 md:gap-8 lg:gap-4 [@media(min-width:800px)]:flex-row">
          <div>
            <div className="[@media(min-width:800px)]:mb-16">
              <Animate animation="fadeInUp" delay={0.2}>
                <h4 className="text-8 mb-4 max-w-[18rem] text-[2rem] font-medium leading-[2.4rem] text-system-disabled sm:max-w-[35rem] sm:text-[2.5rem] sm:leading-[2.875rem] md:text-[3.25rem] md:leading-[3.9rem] lg:max-w-[29.5rem]">
                  Partner with <span className="text-system-sky">Wireless World</span>
                </h4>
                <p className="max-w-[21.4375rem] text-[0.9375rem] leading-[25.5px] text-system-lavendar sm:max-w-[34.5625rem] sm:text-[1.0625rem] sm:leading-[25.5px] md:max-w-full md:text-[1.1875rem] md:leading-[28.5px] lg:max-w-[27.375rem]">
                  Sign up to claim early access and special benefits ahead of our official launch.
                </p>
              </Animate>
            </div>

            <div className="hidden [@media(min-width:800px)]:block">
              <Animate animation="fadeInUp" delay={0.4}>
                <ContactDetails />
              </Animate>
              <Animate animation="fadeInUp" delay={0.5}>
                <SocialLinks />
              </Animate>
            </div>
          </div>

          <ContactForm />
        </div>

        <div className="mt-10 block gap-8 sm:flex sm:justify-between [@media(min-width:800px)]:hidden [@media(min-width:800px)]:justify-items-start">
          <Animate animation="fadeInUp" delay={0.4}>
            <ContactDetails />
          </Animate>
          <Animate animation="fadeInUp" delay={0.5}>
            <SocialLinks />
          </Animate>
        </div>

        <div className="mt-[3.5rem] block sm:hidden">
          <Link
            href="/privacypolicy"
            className="mb-4 block text-[13px] text-system-disabled hover:underline"
          >
            Privacy Policy
          </Link>

          <Link href="/terms" className="block text-[13px] text-system-disabled hover:underline">
            Terms & Conditions
          </Link>
        </div>

        <div className="mt-8 flex items-center justify-between gap-6 sm:mt-20 md:mt-24">
          <Link
            href="/"
            className="relative inline-block h-[24px] w-[111px] sm:h-[26px] sm:w-[118px] md:h-[34px] md:w-[155px]"
          >
            <Image src="/logo-white.svg" alt="logo" className="object-contain" fill />
          </Link>

          <div className="ml-auto flex w-full max-w-[531px] items-center justify-between gap-2">
            <Link
              href="/privacypolicy"
              className="hidden text-[13px] text-system-disabled hover:underline sm:inline md:text-[15px]"
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms"
              className="hidden text-[13px] text-system-disabled hover:underline sm:inline md:text-[15px]"
            >
              Terms & Conditions
            </Link>
            <p className="ml-auto text-[13px] text-system-disabled sm:ml-0 md:text-[15px]">
              Copyright © {currentYear} Wireless World
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
